import { useRef } from 'react';

import { AppointmentAdvancePaymentCreateOnlinePaymentCommand } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

import {
   AdvancePaymentSettlementFormBean,
   AdvancePaymentSettlementFormController,
} from './AdvancePaymentSettlementForm.types';
import { AppointmentAdvancePaymentLinkShowModalEventInterceptor } from './AppointmentAdvancePaymentLinkShowModalEventInterceptor';

type AdvancePaymentSendOnlinePaymentLinkToPatientActionEventInterceptorProps = Readonly<
   Pick<AdvancePaymentSettlementFormController, 'handleSubmit'> & {
      appointmentId: AppointmentId;
      children: JSX.Element;
   }
>;

export const AdvancePaymentSendOnlinePaymentLinkToPatientActionEventInterceptor = (
   props: AdvancePaymentSendOnlinePaymentLinkToPatientActionEventInterceptorProps
): JSX.Element => {
   const phoneNumberRef = useRef<PhoneNumber | null>(null);
   const { executeAsync: sendOnlinePaymentLinkToPatient, data: onlinePaymentId } = useCqrsCommand<
      string,
      AdvancePaymentSettlementFormBean
   >((parameters) => {
      const command = new AppointmentAdvancePaymentCreateOnlinePaymentCommand();
      command.appointmentId = props.appointmentId;
      command.patientPhoneNumber = parameters.patientPhoneNumber!;
      return command;
   });

   const handleAction = props.handleSubmit(async (formData) => {
      phoneNumberRef.current = formData.patientPhoneNumber;
      return sendOnlinePaymentLinkToPatient(formData);
   });

   return (
      <ActionEventInterceptor action={handleAction}>
         <AppointmentAdvancePaymentLinkShowModalEventInterceptor
            onlinePaymentId={onlinePaymentId}
            phoneNumber={phoneNumberRef.current}
         >
            {props.children}
         </AppointmentAdvancePaymentLinkShowModalEventInterceptor>
      </ActionEventInterceptor>
   );
};
